import BackboneElement from './BackboneElement';

import merge from 'lodash/merge';

export default class EncounterDischargeRationale extends BackboneElement {
    static __className = 'EncounterDischargeRationale';

    __objectStructure = {
        type: String,
        text: String,
    };

    constructor(constructJson, className = 'EncounterDischargeRationale') {
        super(constructJson, className);
        this.createAndPopulateStructure(this.__objectStructure, constructJson, this.__objectDefaults);
        this.originalObjJson = this.toJSON();
    }

    toJSON() {
        return merge(super.toJSON(this), this.getJsonForStructure(this.__objectStructure));
    }
}
